import React from 'react';
import { LandingPage } from './pages/LandingPage';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <LanguageProvider data-id="element-1">
        <LandingPage data-id="element-2" />
      </LanguageProvider>
    </ThemeProvider>;
}